const serial_id =  window.JSAMCOInterface && window.JSAMCOInterface.getAndroidDeviceId() || 'GZ20090234300028';
export default {
  appKey: 'cf6ac33c8b267008167c4be5ca53a3a3', 
  appSubkey: 'sei830',
  // Request params
  device_category: 'stb',
  device_id: serial_id, // como obtener device id
  device_manufacturer: 'seirobotics',
  device_model: 'sei830',
  device_name: 'seirobotics', // como arman device Name
  device_so: 'seirobotics', // como obtener device_so
  device_type: 'ott',
  stream_type: '',
  appversion: '1.0', // como obtener appversion
  firmwareversion: '1.0', // como obtener firmware version,
  useEpgPostals: true,
  akamai_id: 'STBSeirobotics',
  nodetv: 'nagratv',
  hideArrowHeader: true,
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  serial_id,
  // akamai_mfwk: 'mfwkstbkaon-api.clarovideo.net',
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkstbrobotics-api.clarovideo.net' : 'http://mfwkstbrobotics-api.clarovideo.net'
  // init: init,
};



// WEBPACK FOOTER //
// ./src/devices/seirobotics/config.js